import { RouteObject } from 'react-router-dom'
import PrivacidadeIncidentesPage from '@/pages/incidentes/PrivacidadeIncidentesPage'

/**
 * Rotas do A13 (Onda 7.3 / 7.6). O convite direto vive dentro de `usuarios-acessos`
 * (rota do A05); aqui entra só a fila do DPO. A entrada de menu é do A02 (`menu.ts`)
 * e fica para o merge.
 */
const rotasA13: RouteObject[] = [
  { path: 'privacidade-incidentes', element: <PrivacidadeIncidentesPage /> },
]

export default rotasA13
